import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import fieldValueShape from './fieldValue';

export default ImmutablePropTypes.contains({
  fieldName: PropTypes.string.isRequired,
  fieldValues: ImmutablePropTypes.listOf(fieldValueShape).isRequired
});
